import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=43bab5ff&"
import script from "./Basic.vue?vue&type=script&lang=ts&"
export * from "./Basic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppMainLogo: require('/home/vsts/work/1/a/NuxtApp/components/app/MainLogo.vue').default})
